import React from "react";
import { motion } from "framer-motion";

export default function KpiCard({ label, value, sub, accent, icon: Icon, index = 0, testid, onClick }) {
  const clickable = typeof onClick === "function";
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.06, ease: "easeOut" }}
      data-testid={testid}
      onClick={onClick}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={clickable ? (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(); } } : undefined}
      className={`relative surface-card p-6 transition-all duration-200 hover:-translate-y-0.5 ${clickable ? "cursor-pointer hover:border-[#38BDF8]/60" : ""}`}
    >
      <div className="flex items-start justify-between">
        <span className="text-xs uppercase tracking-[0.2em] text-slate-400 font-semibold">
          {label}
        </span>
        {Icon && (
          <Icon
            className="h-4 w-4"
            style={{ color: accent || "#71717a" }}
          />
        )}
      </div>
      <div
        className="mt-4 font-display text-3xl md:text-4xl font-light tracking-tight"
        style={accent ? { color: accent } : {}}
      >
        {value}
      </div>
      {sub && <div className="mt-1.5 text-sm text-slate-400">{sub}</div>}
    </motion.div>
  );
}
